module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav perfil"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setAlertAtualizacoes', {
          show: true,
          status: true,
          msg: ''
        })
      }
    }
  }, [_c('b-icon', {
    staticClass: "atualizacoes",
    attrs: {
      "icon": "bell"
    }
  })], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "icon-margin-top sigla-nome-usuario",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        return _vm.getCalendario()
      }
    }
  }, [_c('b-button', {
    staticClass: "calendario"
  }, [_c('b-icon', {
    attrs: {
      "icon": "calendar3"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-calendario"
  }, [_c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("Extra contratual (mês corrente)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Ciclo de pagamento do dia 21 a 20 de cada mês.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 - Fornecedor envia informações para o fop.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia pagamento para matriz.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Do 2º dia útil ao dia 10 – Matriz cria PC.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("SLA (mês anterior)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 – Fechamento SLA SSP.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 ao dia 15 – Fop envia notificação para o fornecedor.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 – Fornecedor envia de acordo para multa/glosa.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia multa/glosa para matriz. (Carta informando o mês do SLA (ex.: junho) e o mês do desconto (ex.: julho)).")])], 1)], 1)]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle perfil",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('div', {
    staticClass: "sigla-nome-usuario"
  }, [_c('p', [_vm._v(_vm._s(_vm.siglaNomeUsuario))])]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(this.$store.state.login.loginUsuario.usuario.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('div', {
    staticClass: "sigla-nome-usuario sigla-nome-usuario-dropdown-menu"
  }, [_c('p', [_vm._v(_vm._s(_vm.siglaNomeUsuario))])]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(this.$store.state.login.loginUsuario.usuario.name) + "\n                " + _vm._s((this.$store.state.login.loginUsuario.grupo.length !== 0) ? this.$store.state.login.loginUsuario.grupo.nome : 'Sem grupo definido') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "grupos-usuario"
  }, _vm._l((_vm.grupo), function(i) {
    return _c('p', [_vm._v(_vm._s(i.nome[0].toUpperCase() + i.nome.substring(1) + ';') + "   ")])
  }), 0)]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.irPara('/perfilusuario')
      }
    }
  }, [_vm._v("Perfil do usuário")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.irPara('/Logout')
      }
    }
  }, [_vm._v("Sair")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b'), _vm._v("SSP")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('b', [_vm._v("Financeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45433736!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NaviBar.vue
// module id = 986
// module chunks = 1